module.exports = __webpack_public_path__ + "img/bulletred.4b0dd524.svg";